module.exports = __webpack_public_path__ + "img/gearbox-engine-icon.8f0839e6.svg";